export default __webpack_public_path__ + "static/media/img_not_playlist.a93b80a9.png";